import { add } from 'sdk/publicKeys';
import { ADD } from 'model/publicKeys';
import { callAction, ORM } from 'util/index';
import { takeEvery } from 'redux-saga/effects';

export default function* saga() {
  yield takeEvery(
    ADD.ACTION,
    callAction({
      api: add,
      dataName: ORM,
      formatSuccessMessage: () => 'Public Key was successfully added',
      type: ADD,
    })
  );
}
